import { useQuery } from '@tanstack/react-query'
import { getContainerCategories } from '@/api/containerCategoriesAPI'

interface Category {
  id: number
  name: string
}

interface CategoriesResponse {
  items: Category[]
}

export const useCategoriesQuery = () => {
  return useQuery<CategoriesResponse>({
    queryKey: ['containerCategories'],
    queryFn: async () => {
      const categories = await getContainerCategories()
      return { items: categories }
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  })
}

export const categoriesToOptions = (categories: Category[] = []) => {
  return [
    { value: 'all', label: 'Todas' },
    ...categories.map((category) => ({
      value: String(category.id),
      label: category.name,
    })),
  ]
}
